import { useEffect, useState } from 'react';

import {
  MEAL_KITS_SLUG,
  EASY_MEAL_KITS_SLUG,
  SERVING,
  SERVINGS,
  CONTAINER,
  MEAL_KIT,
  PROTEIN,
  HEAT_AND_EAT_SLUG,
} from 'lib/constants';

const NutritionTableCaption = ({
  displayUnit,
  menuCategory,
  menuCategoryForMeal,
  servingSizeNetWeight,
  servingSize,
  isTempo,
  nutritionFactsContainerRef,
}) => {
  const [fontSize, setFontSize] = useState(54);
  const isMealKitType = menuCategory === MEAL_KITS_SLUG || menuCategory === EASY_MEAL_KITS_SLUG;
  const isReadyToHeat = isTempo || menuCategory === HEAT_AND_EAT_SLUG;
  const isProtein = menuCategoryForMeal === PROTEIN;
  const servingsPluralize = servingSize === 1 ? SERVING : SERVINGS;

  useEffect(() => {
    const handleResize = () => {
      if (nutritionFactsContainerRef.current) {
        const containerWidth = nutritionFactsContainerRef.current.offsetWidth;
        const newFontSize = containerWidth * 0.12; // font size is 12% of width of nutrition facts container
        setFontSize(newFontSize);
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const itemUnitName = () => {
    if (isMealKitType && !isTempo) return MEAL_KIT;
    if (isReadyToHeat && displayUnit.singular === SERVING) return CONTAINER;

    return displayUnit.singular;
  };

  const servingsCopy = `${!isReadyToHeat ? 'About ' : ''}${servingSize} ${servingsPluralize}${
    !isProtein ? ` per ${itemUnitName()}` : ''
  }`;

  return (
    <caption className="border-b-[9px] border-solid border-b-black-100 px-[2px]">
      <h1
        className="helveticaBlack mb-[0.11em] border-b border-solid border-b-black-100 leading-none"
        style={{ fontSize: `${fontSize}px` }}
      >
        Nutrition Facts
      </h1>
      <p className="text-[1em] leading-none">{servingsCopy}</p>
      <dl className="helveticaBlack mb-[0.25em] flex w-full justify-between text-[1em] leading-none">
        <dt>Serving size</dt>
        <dd>
          1 {SERVING} ({servingSizeNetWeight}g)
        </dd>
      </dl>
    </caption>
  );
};

NutritionTableCaption.propTypes = {
  displayUnit: PropTypes.object.isRequired,
  menuCategory: PropTypes.string.isRequired,
  menuCategoryForMeal: PropTypes.string.isRequired,
  servingSizeNetWeight: PropTypes.number.isRequired,
  servingSize: PropTypes.number.isRequired,
  isTempo: PropTypes.bool.isRequired,
  nutritionFactsContainerRef: PropTypes.object,
};

export default NutritionTableCaption;
